import { createSelector } from 'reselect'
import { getCurrentMedia } from 'redux/currentMedia/selectors'

export const getMediaList = state => state.mediaList

export const getCurrentMediaType = createSelector(
    getCurrentMedia,
    currentMedia => currentMedia.type,
)

export const getMediaAtPosition = createSelector(
    getMediaList,
    (state, position) => position,
    (mediaList, position) => mediaList[position],
)

export const getMediaType = createSelector(
    getMediaAtPosition,
    targetedMedia => targetedMedia && targetedMedia.type
)

export const getCurrentMediaFormat = createSelector(
    getCurrentMedia,
    currentMedia => `${currentMedia.type}/${currentMedia.format}`
)

export const getCurrentMediaLocation = createSelector(
    getCurrentMedia,
    currentMedia => currentMedia.location,
)

export const getCurrentMediaOriginalLocation = createSelector(
    getCurrentMediaLocation,
    currentMediaLocation => currentMediaLocation && currentMediaLocation.original,
)

export const getCurrentMediaProps = createSelector(
    getCurrentMediaLocation,
    getCurrentMediaFormat,
    (location, format) => ({ location, format })
)

export const isMediaLoaded = (state, index) => Boolean(getMediaAtPosition(state, index))
